module.exports = __webpack_public_path__ + "static/hero-article-e0300047812e08a97ef9ce409e0a40de.jpg";